import React, {useEffect, useState} from 'react';

import apiEntryPoint from '../../api/apiSingleton';
import {dateFormatter} from '../../utils/helpers';

export const currencySelectorHoc = Wrapped => props => {
  const [filteredList, setFilteredList] = useState([]);
  const {date, selectedLocation} = props.state;

  useEffect(() => {
    if (props.allCurrencies) {
      apiEntryPoint.finance.listOfActiveCurrencies({
        date: dateFormatter(date),
        city: selectedLocation.key
      }).then(existCurrencies => {
        const currenciesFinalList = props.allCurrencies.reduce((result, item) => {
          const existList = item.options.filter(it => existCurrencies.includes(it.value));

          return existList.length ? [...result, {label: item.label, options: existList}] : result;
        }, []);

        setFilteredList(currenciesFinalList);
      }).catch(e => {
        throw new Error(e.message);
      });
    }
  }, [date, selectedLocation]);
  return <Wrapped {...props} listData={props.allCurrencies ? filteredList : props.listData} />;
};
